import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

interface ForbiddenPageProps {
  text: string
}

const ForbiddenPage = ({ text }: ForbiddenPageProps) => {
  const { t } = useTranslation()
  const resetError = () => {
    const resetEvent = new CustomEvent('resetError')
    document.dispatchEvent(resetEvent)
  }

  return (
    <div className="flex items-center justify-center flex-col min-h-screen bg-gradient-to-r">
      <div className="px-6 py-10 bg-white rounded-lg shadow-md sm:px-12 sm:py-16 lg:px-20 lg:py-24">
        <div className="flex flex-col items-center">
          <h1 className="text-6xl font-bold text-blue-600 sm:text-8xl">403</h1>

          <h6 className="my-2 text-2xl font-bold text-center text-gray-800 md:text-3xl">
            {text}
          </h6>

          <p className="mb-8 text-center text-gray-500 md:text-lg">
            {t('youDoNotHaveAccessToThisPage')}
          </p>

          <Link
            to="/"
            className="px-6 py-2 text-sm font-semibold text-blue-800 bg-blue-100"
            onClick={resetError}
          >
            {t('goToHome')}
          </Link>
        </div>
      </div>
    </div>
  )
}

export default ForbiddenPage
